<template>
  <div class="asc-label-box" :style="{ backgroundColor: bgColor }">
    <asc-label
      size="sm"
      :value="value"
      :style="{ backgroundColor: bgColor, color: color }"
    ></asc-label>
  </div>
</template>

<script>
import AscLabel from './AscLabel'
import variables from '@/styles/_varsJs.scss'

export default {
  name: 'AscLabelBox',

  components: {
    AscLabel,
  },

  props: {
    value: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: variables.primarywhite + ' !important;',
    },
    bgColor: {
      type: String,
      default: variables.warningbase,
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-label-box {
  margin-left: 5px;
  line-height: 16px;
  height: 18px;
  border-radius: 8px;
  padding: 0 8px;
  display: inline-block;
  word-break: normal;
  background-color: $gray-300;
  width: fit-content;
}
</style>
